import { Button } from "primereact/button";

import { buttonAdd, buttonAnnul } from "_constants";

export const SingleStepFooter = ({
  dismiss,
  form,
  labelSubmit = buttonAdd,
  template,
  buttonType = "submit",
}: any) => {
  return (
    <div className="flex-container justify-between align-center">
      <div>{template}</div>
      <div>
        <Button
          label={buttonAnnul}
          onClick={dismiss}
          text
          severity="secondary"
        />
        <Button
          type={buttonType}
          form={form}
          label={labelSubmit}
          className="min-w-120 margin-0"
        />
      </div>
    </div>
  );
};
